import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';

import persistState from 'redux-localstorage';
import { reducer as formReducer } from 'redux-form';

import * as reducers from 'ducks';

import {
  reducer as beesReducer,
  middleware as beesMiddleware,
} from 'redux-bees';

const reducer = combineReducers({
  ...reducers,
  form: formReducer,
  bees: beesReducer,
});

/* eslint-disable no-underscore-dangle */
const devTools = window.__REDUX_DEVTOOLS_EXTENSION__
  ? window.__REDUX_DEVTOOLS_EXTENSION__()
  : f => f;

const createStoreWithMiddlewares = compose(
  applyMiddleware(thunkMiddleware),
  applyMiddleware(beesMiddleware()),
  persistState(['session', 'joyride']),
  devTools, // Usa il devTools calcolato
)(createStore);
 /* eslint-enable */

export default createStoreWithMiddlewares(reducer);



// WEBPACK FOOTER //
// ./app/store.js